<div class="relative flex items-center justify-center">
  <div class="absolute left-0 z-10 flex h-full w-12 flex-col justify-center bg-gradient-to-r from-background-white to-transparent">
    @if (isBackButtonVisible()) {
      <lib-perio-exam-carousel-button [type]="'back'" (buttonClick)="moveToPreviousItem()" />
    }
  </div>
  <div class="overflow-x-hidden">
    <div #carouselContainer class="flex gap-4 transition-transform duration-700">
      @for (perioExamDirection of perioExamDirections(); track perioExamDirection) {
        <lib-perio-exam-direction-card
          class="flex-shrink-0 transition-transform duration-700"
          [selected]="selectedCarouselItem() === $index"
          [perioExamDirection]="perioExamDirection"
          [available]="perioExamDirection.available"
          [ngClass]="{
            'scale-90': activeCarouselItem() !== $index,
            'scale-100': activeCarouselItem() === $index
          }"
          (cardClick)="onCardClicked($event)"
        />
      }
    </div>
  </div>
  <div class="absolute right-0 z-10 flex h-full w-12 flex-col justify-center bg-gradient-to-r from-transparent to-background-white">
    @if (isNextButtonVisible()) {
      <lib-perio-exam-carousel-button [type]="'next'" (buttonClick)="moveToNextItem()" />
    }
  </div>
</div>
